import { ReactNode, useState } from 'react';
import { ErrorContext } from './use-error';

interface ErrorBoundaryProps {
    children: ReactNode;
}

export const ErrorProvider = ({ children }: ErrorBoundaryProps) => {
    const [error, setError] = useState<Error | null>(null);
    const values = { error, setError };

    if (error) {
        return (
            <div className="error-container">
                <h2>خطایی رخ داده است</h2>
                <p>{error.message}</p>
                <button onClick={() => setError(null)}>تلاش مجدد</button>
            </div>
        );
    }

    return <ErrorContext.Provider value={values}>{children}</ErrorContext.Provider>;
};
